import Icon from '../components/Icon.vue'

Icon.register({
  vihara: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M632.9 400.7c5.4 3.6 7.7 9.6 7 15.3-0.6 5-3.6 9.8-8.7 12.3l-55.2 19.7v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-160v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-160v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48l-55.2-19.7c-5.1-2.6-8.1-7.3-8.7-12.3-0.7-5.7 1.6-11.7 7-15.3l88.9-48.7v-64l-55.2-17.7c-11.8-5.9-11.8-22.7 0-28.6l119.2-49.7v-64l-27.3-16.3c-7.7-7.7-5.6-20.7 4.2-25.6l183.2-86.1 183.2 86.1c9.8 4.9 11.9 17.9 4.2 25.6l-27.3 16.3v64l119.2 49.7c11.8 5.9 11.8 22.7 0 28.6l-55.2 17.7v64zM224 128v64h192v-64h-192zM160 352h320v-64h-320v64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/vihara.js
// module id = 2090
// module chunks = 0